<template>
<div class="no-px2rem">
  <!-- 横向不分段进度条 -->
  <div class="rich-progress" v-if="direction === 'horizontal' && !isSubsection">
    <slot name="start"></slot>
    <div class="rich-progress-content">
      <div class="rich-progress-bg"></div>
      <div class="rich-progress-progress" :style="[{width: value + '%'}]"></div>
    </div>
    <p  class="rich-progress-end">
      <slot name="end"></slot>
    </p>
  </div>
  <!-- 横向分段进度条 -->
  <div class="rich-progress rich-progress-horizontal">
    <div class="rich-progress-scroll-shadow left" v-show="scrollInfo.showLeft"></div>
    <div class="rich-progress-scroll-shadow right" v-show="scrollInfo.showRight"></div>
    <div class="scroll-panel" ref="scrollPanel">
      <ul class="rich-progress-group" ref="group" v-if="direction === 'horizontal' && isSubsection">
        <div class="group-tip" :style="getItemStyle(false)">
          <p class="top">{{content.top}}</p>
          <p class="bottom">{{content.bottom}}</p>
        </div>
        <li class="rich-progress-item" v-for="(v, i) in config" :key="i"
          :class="{'item-box-light': v.isLight, 'item-box-finish': current >= +v.value, 'item-box-wait':current < v.value }"
          :style="getItemStyle(v.isLight)">
          <div class="item-box">
            <div class="line" :style="[{width: `calc(100% - ${v.isLight?26:20}px)`}]">
              <p class="line-bar" :ref="(getProgress(v, i)>0 && getProgress(v, i) < 100)?'currLine':''" :style="[{width: `${getProgress(v, i)}%`}]"></p>
            </div>
            <div class="main-content">
              <p class="subtitle" ref="subtitle">{{v.detail}}</p>
              <p class="horizontal-dot-bg dot-bg" :ref="v.isLight?'currDot':''">
                <span class="dot"></span>
              </p>
              <p class="main-title" ref="maintitle">{{v.mainTitle ? v.mainTitle : i + 1 }}</p>
            </div>
          </div>
        </li>
      </ul>
      <slot name="content"></slot>
    </div>
  </div>
  <!-- 垂直分段进度条 -->
  <div class="rich-progress" v-if="direction === 'vertical'">
    <ul class="rich-progress-group">
      <li class="rich-progress-item" v-for="(v, i) in config" :key="i"
        :class="{'item-box-light': v.inProgress, 'item-box-no-light': findProgress < i}">
        <div class="item-box">
          <p class="vertical-dot-bg dot-bg">
            <span class="dot"></span>
          </p>
          <div class="main-content">
            <p class="line"></p>
            <p class="text-content">
              <span class="main-title">{{v.mainTitle}}</span>
              <span class="subtitle">{{v.detail}}</span>
            </p>
          </div>
        </div>
      </li>
    </ul>
  </div>


</div>
</template>

<script type="text/ecmascript-6">
  const COMPONENT_NAME = 'rich-progress'
  const DIRECTION_H = 'horizontal'
  const DIRECTION_V = 'vertical'

  export default {
    name: COMPONENT_NAME,
    props: {
      value: {
        type: Number,
        default: 0,
        validator: value => value >= 0 && value <= 100
      },
      // 分段进度条可用参数
      isSubsection: false,
      direction: {
        type: String,
        default: DIRECTION_H,
        validator (val) {
          return val === DIRECTION_H || val === DIRECTION_V
        }
      },
      paramsn: {
        type: Array,
        default: () => [],
        validator (val) {
          let flag = true
          // 校验有value时必须全部都有value，且是逐步增长的
          let res = val.map(e => e.value).filter(e => e !== undefined)
          if (res.length && res.length !== val.length) flag = false
          else if (res.length) {
            let num = res[0]
            for (let i = 1; i < res.length; i++) {
              if (num >= res[i]) {
                flag = false
                break
              }
              num = res[i]
            }
          }
          return flag
        }
      },

      // 仅横向分段进度条可用参数
      current: {
        type: Number,
        default: 0
      },
      content: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {
        config: this.paramsn,
        per: 0,
        pos: 0,
        lastTextOverflow: 0,
        scrollInfo: {showLeft: false, showRight: false, offset: 0}
      }
    },
    computed: {
      findProgress () {
        let inProgress = 0
        if (this.direction === DIRECTION_H) inProgress = null
        this.config && this.config.forEach((item, i) => {
          if (item.inProgress) {
            inProgress = i
          }
        })
        return inProgress
      }
    },
    created () {
      const {isSubsection, direction} = this
      if (isSubsection && direction === DIRECTION_H) {
        this.calcProgress()
      }
    },
    mounted () {
      const {isSubsection, direction} = this
      if (isSubsection && direction === DIRECTION_H) {
        this.$refs.scrollPanel && this.$refs.scrollPanel.addEventListener('scroll', this.handleScroll)

        const topOverflow = ((this.$refs.subtitle && this.$refs.subtitle.pop().clientWidth) - 20) / 2 // 计算最后一个文字节点溢出的宽度 （20 一个节点的宽度）
        const bottomOverflow = ((this.$refs.maintitle && this.$refs.maintitle.pop().clientWidth) - 20) / 2 // 计算最后一个文字节点溢出的宽度 （20 一个节点的宽度）
        this.lastTextOverflow = Math.max(topOverflow, bottomOverflow)
        const realWidth = this.paramsn.length * 78 + this.lastTextOverflow - 2
        if (realWidth > this.$refs.scrollPanel.clientWidth) this.scrollInfo.showRight = true
      }
    },
    destroyed () {
      const {isSubsection, direction} = this
      if (isSubsection && direction === DIRECTION_H) {
        this.$refs.scrollPanel && this.$refs.scrollPanel.removeEventListener('scroll', this.handleScroll)
      }
    },
    methods: {
      getPosition () {
        const {currLine, currDot, group} = this.$refs
        let pos = 0
        if (currLine && currLine[0]) {
          pos = this.getOffset(currLine[0], group) + currLine[0].clientWidth
        } else if (currDot && currDot[0]) {
          pos = this.getOffset(currDot[0], group) + 10
        }

        const {offset} = this.scrollInfo
        return pos - offset - 1
      },
      getOffset (target, parent) {
        let num = target.offsetLeft || 0
        if (target.offsetParent && target.offsetParent !== parent) {
          num = target.offsetLeft + this.getOffset(target.offsetParent, parent)
        }
        return num
      },
      handleScroll (e) {
        const ele = e.target || e.srcElement
        const num = ele.scrollLeft
        const realWidth = this.paramsn.length * 78 + this.lastTextOverflow - 2 // 浮动范围

        this.scrollInfo = {showLeft: num > 0, showRight: realWidth > ele.clientWidth && (num + ele.clientWidth) <= realWidth, offset: num}
        this.$emit('scroll')
      },
      calcProgress () {
        const {paramsn, current} = this
        let list = paramsn.map((e, i) => {
          const {mainTitle, detail, value} = e
          return {mainTitle, detail, value: value || i + 1}
        })
        let vals = list.map(e => e.value)
        let flag = false
        for (let i = vals.length; i >= 0; i--) {
          if (current >= vals[i]) {
            if (current === vals[i] || i === (vals.length - 1)) list[i].isLight = true
            list[i].inProgress = true
            flag = true
            if (i !== vals.length - 1) {
              this.per = (((current - vals[i]) / (vals[i + 1] - vals[i])) * 100).toFixed(2)
            }
            break
          }
        }
        if (current && !flag) { // 未达成第一阶段的per
          this.per = (((current) / vals[0]) * 100).toFixed(2)
        }
        this.config = list
      },
      getProgress (v, i) {
        const {findProgress, per} = this
        if ((i === 0 && findProgress === null) || (findProgress !== null && findProgress + 1 === i)) {
          return per
        }
        if (findProgress >= i) return 100
        return 0
      },
      getItemStyle (isLight) {
        const {paramsn} = this
        const len = paramsn.length || 1
        const subWidth = `calc(${(100 / len).toFixed(4)}% - ${Math.ceil(this.lastTextOverflow / len)}px)` // 向上取整，宁可右边有空隙，足够显示的时候不出滚动条
        if (isLight) {
          return [{width: subWidth, minWidth: '84px'}]
        }
        return [{width: subWidth, minWidth: '78px'}]
      }
    }
  }
</script>



<style lang="stylus" rel="stylesheet/stylus">
@import "~@/assets/styles/d/variable.styl"
.no-px2rem
  .rich-progress
    width: 100%
    display: flex
    align-items center
    .rich-progress-content
      width: 100%
      .rich-progress-bg
        width: 100%
        max-width: 100%
        min-height: 4px
        background-color: $color_gery_5_90
        transform: translateY(50%)
        border-radius: 7px
      .rich-progress-progress
        max-width: 100%
        min-height: 4px
        border-radius: 7px
        color_brands_1_100-bgc()
        transition: width 500ms, height 200ms
        transform: translateY(-50%)
    .rich-progress-end
      margin-left: 12px
      font_family_Light()
      font-size: $fontsize-F11
      font-weight: 200


      
// 垂直进度条
.no-px2rem 
  .rich-progress-group
    width: 100%
    box-sizing: border-box
    padding-left: 9px
    .rich-progress-item 
      margin:0 0 4px;
      position: relative;
      display: flex;
      &:last-child 
        .item-box
          .line
            display none
          btitle
            margin-left: 4px
            padding-bottom: 0
        .main-content
          min-height: 10px
      &:first-child 
        .item-box
          .dot-bg
            background: none
    .item-box 
      font-size: $fontsize-F08
      font_family_Medium()
      .vertical-dot-bg
        width: 18px;
      .dot-bg
        height: 12px;
        position: absolute;
        border-radius: 18px;
        left: -7px;
        top: 1px
        display: flex
        justify-content center
        align-items center
        .dot 
          display: inline-block
          width: 12px
          height: 12px
          border-radius: 12px
          color_brands_1_100-bgc()
      .main-content
        display flex
        min-height: 58px
        width 100%
        margin-top: 2px
        .line
          margin-top: 16px
      .text-content
        padding-left: 15px
        display: flex 
        flex-direction column
        .main-title
          margin-top: -3px
      .main-title 
        color: $color_gery_1_0 
        font_family_Medium()
      .subtitle 
        font-size: $fontsize-F10
        font_family_Light()
        padding-bottom: 40px 
        margin-top: 4px
        color: $color_gery_1_0
      .line 
        width: 4px
        align-items: stretch
        border-radius 20px
        flex-shrink 0
        color_brands_1_100-bgc()
        

    // 正在进行中的状态
    .item-box-light
      .dot-bg
        color_background_1_100-bgc()
        width: 18px;
        height: 18px;
        .dot 
          color_brands_1_100-bgc()
      .main-title
        font_family_Medium()
        font-size: $fontsize-F08
        margin-bottom: 7px;   
        color_brands_1_100()
        margin-top: 2px
      .subtitle
        color_brands_1_100()
        margin-top: 0
      .line 
        background: $color_gery_5_90 !important
      .main-content
        .line
          margin-top: 22px
      
    // 未开始的状态
    .item-box-no-light
      .dot-bg
        .dot
          background: $color_gery_5_90 !important
      .line 
        background: $color_gery_5_90 !important
      .main-title
        color: $color_gery_3_60
        font_family_Light()
        // margin-bottom: 6px;   
      .subtitle 
        color: $color_gery_3_60
        font_family_Light()


// 横向分段进度条
.no-px2rem 
  .rich-progress-horizontal
    display block
    position relative
    .scroll-panel
      overflow-x auto
    .rich-progress-scroll-shadow
      width 30px
      height 100%
      position absolute
      top 0
      z-index 1
      pointer-events none
      &.left
        left 0
        background: linear-gradient(-90deg, rgba(255,255,255,0.00) 0%, rgba(255,255,255,0.85) 100%);
      &.right
        right 0
        background: linear-gradient(90deg, rgba(255,255,255,0.00) 0%, rgba(255,255,255,0.85) 100%);
    .rich-progress-group
      position relative
      padding 0
      white-space nowrap

      .rich-progress-item
        display inline-block
        min-width 78px
        .item-box
          width 100%
        &:last-child .item-box .line
          display block
      .main-content
        display flex
        align-items center
        justify-content flex-start
        flex-direction column
        width 20px
        .subtitle
          padding 0
          margin 0
        .dot-bg
          height: 18px
          margin 11px 0
      .item-box
        display flex
        align-items center
        flex-shrink 0
        .line 
          width calc(100% - 20px)
          min-width: 58px;
          height 4px
          border-radius: 2px
          flex-shrink 0
          background: $color_gery_5_90 !important
          .line-bar 
            border-radius: 2px
            height 100%
            color_brands_1_100-bgc()
        .main-content
          .main-title
            margin 0
            padding 0
            font_family_Light()
            font-size: $fontsize-F10
          .subtitle
            min-width: 12px
            min-height: 14px
            font_family_Light()
            font-size: $fontsize-F10
        .dot-bg
          position relative
          left 0 
          top 0
          .dot
            background: $color_gery_5_90 
    
      .group-tip
        position absolute
        display flex
        flex-direction column
        height 100%
        justify-content space-between
        color: #999
        font-family: 'Aspira Regular'
        font-size: $fontsize-F11
        .top
          padding-top 2px
        .bottom
          width: calc(100% - 20px)
          overflow:hidden
          text-overflow: ellipsis
          white-space: nowrap
          padding-bottom 4px

    // 当前
    .item-box-light
      .item-box .dot-bg .dot 
          color_brands_1_100-bgc() !important
      .main-content
        width 26px
        .subtitle,.main-title
          font_family_Medium()
          color_brands_1_100()
    // 已完成
    .item-box-finish
      .item-box .dot-bg .dot 
          color_brands_1_100-bgc() !important
      .item-box .main-content
        .subtitle, .main-title
          font_family_Medium() !important
    .item-box-wait
      .item-box .main-content
        .subtitle, .main-title
            color: $color_gery_3_60


.xtd-reward-container
  .no-px2rem:after
    width auto!important
    border 0!important
</style>
